import { PORTAL_CONTAINER_ID, Route, TextKey, useIsMobile } from '@mews-distributor/common';
import { LocalizedText } from '@mews/framework/localization';
import { NAVBAR_MIN_HEIGHT, NAVBAR_MIN_HEIGHT_DESKTOP } from '@mews-distributor/ui';
import { APPBAR_DESKTOP_HEIGHT, AppCanvas, AppView, SkipLinks } from '@optimus-web/core';

import { CheckoutView } from '../views/checkout';
import { Confirmation } from '../views/confirmation';
import { Dates } from '../views/dates';
import { Enterprises } from '../views/enterprises';
import { Rates } from '../views/rates';
import { SpaceCategories } from '../views/spaceCategories';
import { Summary } from '../views/summary';

import { StandaloneDialog } from './common/StandaloneDialog';
import { RateCompare } from './RateCompare';
import { Router } from './Router';
import { Toolbar } from './Toolbar';

const views = {
    [Route.Dates]: Dates,
    [Route.Properties]: Enterprises,
    [Route.SpaceCategories]: SpaceCategories,
    [Route.Rates]: Rates,
    [Route.Summary]: Summary,
    [Route.Checkout]: CheckoutView,
    [Route.Confirmation]: Confirmation,
};

const toolbarHeight = APPBAR_DESKTOP_HEIGHT + NAVBAR_MIN_HEIGHT;
const toolbarHeightDesktop = APPBAR_DESKTOP_HEIGHT + NAVBAR_MIN_HEIGHT_DESKTOP;

const list = [
    { text: <LocalizedText textKey={TextKey.Toolbar} />, link: '#toolbar' },
    { text: <LocalizedText textKey={TextKey.SiteNavigation} />, link: '#navigation' },
    { text: <LocalizedText textKey={TextKey.MainContent} />, link: '#main' },
];

export const App = () => {
    const isMobile = useIsMobile();

    return (
        <AppCanvas>
            <SkipLinks label={<LocalizedText textKey={TextKey.SkipTo} />} list={list} />
            <Toolbar />
            <AppView offset={isMobile ? toolbarHeight : toolbarHeightDesktop} id="main">
                {/* @ts-expect-error $TSFixMeError: Type '{ views: { dates: FC<Omit<{}, never>>; properties: FC<Omit<{}, never>>; categories: FC<Omit<{}, never>>; rates: FC... */}
                <Router views={views} />
            </AppView>
            <RateCompare />
            <StandaloneDialog />
            <div id={PORTAL_CONTAINER_ID} />
        </AppCanvas>
    );
};
